import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ImagesGenerateTab } from './generate/ImagesGenerateTab';
import { VideosGenerateTab } from './generate/VideosGenerateTab';

/**
 * GenerateTab - Parent tab component for AI-powered media generation
 *
 * Contains nested tabs for:
 * - Images: Text-to-image and reference image composition
 * - Videos: Video generation from text, images, or AI-generated images
 *
 * Following Pumpd's tab pattern with nested navigation
 */
export const GenerateTab: React.FC = () => {
  const [activeSubTab, setActiveSubTab] = useState('images');

  return (
    <div className="space-y-4">
      <Tabs value={activeSubTab} onValueChange={setActiveSubTab} className="w-full">
        <TabsList className="grid grid-cols-2 w-full sm:w-auto">
          <TabsTrigger value="images">Images</TabsTrigger>
          <TabsTrigger value="videos">Videos</TabsTrigger>
        </TabsList>

        <TabsContent value="images" className="mt-4">
          <ImagesGenerateTab />
        </TabsContent>

        <TabsContent value="videos" className="mt-4">
          <VideosGenerateTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default GenerateTab;
